export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BookToday.vue?vue&type=template&id=709fdf62&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BookToday.vue?vue&type=template&id=709fdf62&scoped=true
// module id = 165
// module chunks = 0